module.exports = __webpack_public_path__ + "img/14.02cc09af.svg";